<template>
    <div id="message_box" class="message_box">
        <el-popover v-model="visible" trigger="click" @show="onShow" @hide="onHide">
            <el-badge :is-dot="isDot" slot="reference">
                <el-button type="text" size="mini" icon="el-icon-message-solid">导出记录</el-button>
            </el-badge>
            <ul class="table_box" v-if="tableData.length">
                <li v-for="(item, index) in tableData" :key="index">
                    <i :class="item.iconLeft"></i>
                    <el-tooltip :content="item.exportName" placement="left">
                        <p :style="{color: item.color}">{{ item.exportName }}</p>
                    </el-tooltip>
                    <p class="p_2">{{ item.createTime | dateFormatToSecond }}</p>
                    <el-progress class="line_box" v-if="item.status != 3" :percentage="item.progress" :color="item.color" :text-inside="true" :stroke-width="15"></el-progress>
                    <p class="p_2" :style="{color: item.color, 'font-weight': 'bold'}" v-else>导出失败</p>
                    <i :class="item.iconRight" @click="onHandle(item)"></i>
                </li>
            </ul>
            <el-empty v-else :image-size="90" description="暂无导出记录"></el-empty>
        </el-popover>
    </div>
</template>

<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import axios from 'axios'
import { mapState } from 'vuex'
import envConfig  from '@/common/env'

export default {
    props: [],
    data () {
        return {
            stompClient: null,
            visible: false,
            isDot: false,
            tableData: [],
            cancelKey: null,
        }
    },
    computed: {

    },
    created () {
        
    },
    mounted () {
        this.$eventBus.$off().$on("sendExportClick", (e) => {
            console.log("通知页面接收点击导出按钮传的参数->", e)
            // this.isDot = true;
            this.cancelKey = null;
        })
        this.connection();
    },
    beforeDestroy () {
        console.log("--- 卸载前 ---")
		this.disconnect();
	},
    destroyed () {
        console.log("--- 卸载 ---")
        this.disconnect();
    },
    methods: {
        onShow() {
            this.isDot = false;
            this.getExportList();
        },
        onHide() {

        },

        connection() { //websocket建立连接
            let authInfo = JSON.parse(window.localStorage.getItem("authInfo"));
            let userId = authInfo.id;
			let socket = new SockJS(`${envConfig.marbasUrl}/rescue-master/marbas/api/ws-export`);
			this.stompClient = Stomp.over(socket);
			this.stompClient.connect({}, () => {
                console.log('--- websocket建立连接成功 ---')
                this.stompClient.subscribe(`/topic/export/${userId}`, this.onSocketSuccess);
			}, this.onSocketError);
		},
        onSocketSuccess(res) {
			console.log('--- websocket获取消息成功 ---', res, JSON.parse(res.body))
            let { exportKey } = JSON.parse(res.body);
			if(exportKey) {
                this.isDot = true;
            }
		},
		onSocketError(err) {
			console.log(err)
		},
        disconnect() { // 断开连接
			if (this.stompClient) {
				this.stompClient.disconnect();
			}
		},

        getExportList() {
            this.$axios.get(`${envConfig.marbasUrl}/rescue-master/marbas/api/export/progress`).then(res => {
                let { code, data } = this.AppUtils.checkResponse(res);
                if(code == 0 && data) {
                    data.forEach(item => {
                        if(item.status == 1) {
                            item.iconLeft = "el-icon-loading";
                            item.color = "#E6A23C";
                            item.iconRight = "el-icon-circle-close";
                            item.progress = item.progress ? parseFloat(item.progress) : 0;
                        } else if(item.status == 2) {
                            item.iconLeft = "el-icon-success";
                            item.color = "#67C23A";
                            item.iconRight = "el-icon-download";
                            item.progress = 100;
                        } else if(item.status == 3) {
                            item.iconLeft = "el-icon-error";
                            item.color = "#F56C6C";
                            item.iconRight = "el-icon-refresh1";
                            item.progress = 0;
                        }
                        if(this.cancelKey && this.cancelKey == item.exportKey) {
                            item.status == 3
                            item.iconLeft = "el-icon-error";
                            item.color = "#F56C6C";
                            item.iconRight = "el-icon-refresh1";
                        }
                    })
                    this.tableData = data;
                }
            })
        },

        onHandle(row) {
            console.log(row)
            if(row.status == 1) {
                this.onCancel(row);
            } else if(row.status == 2) {
                this.onDownload(row);
            } else if(row.status == 3) {
                
            }
        },

        onDownload(row) {
            return window.open(`${row.fileUrl}?t=${Math.random()}`, "_blank");
        },

        onRefresh(row) {

        },

        onCancel(row) {
            let _this = this;
            let url = `${envConfig.marbasUrl}/rescue-master/marbas/api/export/cancel`;
            let { exportKey } = row;
            this.$confirm('此操作将删除正在下载中的文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$axios.post(url, { exportKey }).then((res) => {
                    let { code, data } = this.AppUtils.checkResponse(res);
                    if(code == 0 && data) {
                        let { cancelSuccess, exportKey } = data;
                        if(cancelSuccess) {
                            _this.$message({
                                type: "success",
                                message: "操作成功",
                                customClass: "cancel_custom_class"
                            })
                            _this.cancelKey = exportKey;
                            setTimeout(() => {
                                _this.visible = true;
                            }, 100)
                        }
                    }
                })
            }).catch(() => {})
        },

    }
}
</script>

<style scoped >
    .table_box {
        width: 100%;
        padding: 0 10px 0 0;
        text-align: left;
    }
    .table_box li {
        margin: 10px auto;
        display: flex;
        /* justify-content: center; */
        align-items: center;
    }
    .table_box li p {
        margin: 0 10px;
        width: 150px; /* 设置容器的宽度 */
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden; /* 隐藏溢出的文本 */
        text-overflow: ellipsis; /* 显示省略号 */
        font-weight: 500;
    }
    .table_box li .p_2 {
        width: 130px;
        font-size: 12px;
        color: #909399;
    }
    .table_box li .line_box {
        width: 100px;
        margin: 0 10px 0 0;
    }
    .el-icon-success,.el-icon-download {
        font-size: 15px;
        color: #67C23A;
    }
    .el-icon-error,.el-icon-refresh {
        font-size: 15px;
        color: #F56C6C;
    }
    .el-icon-loading,.el-icon-circle-close {
        font-size: 15px;
        color: #E6A23C;
    }
    .el-icon-download,.el-icon-refresh,.el-icon-circle-close {
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
    }
    .yes {
        color: #303133;
    }
    .no {
        color: #C0C4CC;
    }
    .message_box /deep/ .el-icon-message-solid {
        font-size: 16px;
    }
    .message_box /deep/ .el-badge__content.is-fixed {
        top: 10px;
        right: 0px;
    }
</style>
<style>
    .cancel_custom_class {
        z-index: 999999!important;
    }
</style>


// WEBPACK FOOTER //
// exportMessage.vue?7bde88a3